enum Prefix {
    FLOAT = 'float-',
    OVERFLOW = 'overflow-',
    Z_INDEX = 'z-',
    FLEX = 'flex-',
    ORDER = 'order-',
    GRID_TEMP_COLS = 'grid-cols-',
    GRID_TEMP_ROWS = 'grid-rows-',
    COLUMN = 'col-',
    ROW = 'row-',
    GAP = 'gap-',
    JUSTIFY_CONTENT = 'justify-',
    JUSTIFY_ITEMS = 'justify-items-',
    JUSTIFY_SELF = 'justify-self-',
    ALIGN_CONTENT = 'content-',
    ALIGN_ITEMS = 'items-',
    ALIGN_SELF = 'self-',
    PLACE_CONTENT = 'place-content-',
    PLACE_ITEMS = 'place-items-',
    PLACE_SELF = 'place-self-',
    BORDER = 'border-',
    DIVIDE = 'divide-',
    RING = 'ring-',
    MARGIN = 'm',
    PADDING = 'p',
    SPACE_BETWEEN = 'space-',
    WIDTH = 'w-',
    HEIGHT = 'h-',
    MIN_WIDTH = 'min-w-',
    MAX_WIDTH = 'max-w-',
    MIN_HEIGHT = 'min-h-',
    MAX_HEIGHT = 'max-h-',
    TEXT = 'text-',
    FONT = 'font-',
    BACKGROUND = 'bg-',
    LETTER_SPACING = 'tracking-',
    LINE_HEIGHT = 'leading-',
    OPACITY = 'opacity-',
    ROUNDED = 'rounded-',
    PLACEHOLDER = 'placeholder-',
    SHADOW = 'shadow-',
    INSET = 'inset-',
    INSET_X = 'inset-x-',
    INSET_Y = 'inset-y-',
    LEFT = 'left-',
    RIGHT = 'right-',
    TOP = 'top-',
    BOTTOM = 'bottom-',
    CURSOR = 'cursor-',
    TRANSITION = 'transition-',
    TRANSITION_DURATION = 'duration-',
    TRANSITION_DELAY = 'delay-',
}
export default Prefix;